<footer class="footer">
  <div class="sectpad container section footpad pl-0">
    <div class="p-3 pt-5 col-sm-12 row m-0">
      <div class="col-sm-6 col-md-3 col-lg-2 col-6 pl-0">
        <h5>Company</h5>
        <ul class="list-unstyled text-small">
          <li>
            <a
              class="text-muted"
              href="javascript:void(0)"
              routerLink="/get-started"
              >Residential</a
            >
          </li>
          <li>
            <a
              class="text-muted"
              href="javascript:void(0)"
              routerLink="/commercial/get-started"
              >Commercial</a
            >
          </li>
          <li><a class="text-muted" routerLink="/giveback">Giveback</a></li>
        </ul>
      </div>
      <div class="col-sm-6 col-md-3 col-lg-2 col-6 pl-0 webview">
        <h5>Support & Learn</h5>
        <ul class="list-unstyled text-small">
          <li>
            <a
              class="text-muted"
              href="javascript:void(0)"
              routerLink="/faq"
              (click)="footerClick('faq')"
              >FAQ</a
            >
          </li>
          <li>
            <a
              class="text-muted"
              href="javascript:void(0)"
              routerLink="/blog"
              (click)="footerClick('blog')"
              >Blog</a
            >
          </li>
          <li>
            <a
              class="text-muted"
              href="javascript:void(0)"
              routerLink="/faq/contact-us"
              >Contact Us</a
            >
          </li>
          <li>
            <a
              class="text-muted"
              href="javascript:void(0)"
              routerLink="/faq/privacy-policy"
              >Privacy Policy</a
            >
          </li>
          <li>
            <a
              class="text-muted"
              href="javascript:void(0)"
              routerLink="/faq/terms-of-service"
              >Terms of Service</a
            >
          </li>
        </ul>
      </div>
      <div class="col-sm-6 col-md-3 col-lg-2 col-6 pl-0 mobileview">
        <h5>Support & Learn</h5>
        <ul class="list-unstyled text-small">
          <li>
            <a class="text-muted" href="javascript:void(0)" routerLink="/faq"
              >FAQ</a
            >
          </li>
          <li>
            <a class="text-muted" href="javascript:void(0)" routerLink="/blog"
              >Blog</a
            >
          </li>
          <li>
            <a
              class="text-muted"
              href="javascript:void(0)"
              routerLink="/faq/contact-us"
              >Contact Us</a
            >
          </li>
          <li>
            <a
              class="text-muted"
              href="javascript:void(0)"
              routerLink="/faq/privacy-policy"
              >Privacy Policy</a
            >
          </li>
          <li>
            <a
              class="text-muted"
              href="javascript:void(0)"
              routerLink="/faq/terms-of-service"
              >Terms of Service</a
            >
          </li>
        </ul>
      </div>
      <div class="col-sm-6 col-md-3 col-lg-2 col-6 pl-0" *ngIf="showLogin">
        <h5>Account</h5>
        <ul class="list-unstyled text-small">
          <li>
            <a class="text-muted" href="javascript:void(0)" routerLink="/login"
              >Login</a
            >
          </li>
        </ul>
      </div>
      <div
        class="col-sm-6 col-md-3 col-lg-6 col-6 pl-0 text-right mob-align-left"
      >
        <div class="ourcommunity">
          <h5>Join Our Community</h5>
          <div class="col-sm-12 p-0 pt-1 text-right mob-align-left">
            <div class="float-right d-flex">
              <a
                href="https://www.facebook.com/honestgorilla1/"
                target="_blank"
              >
                <img
                  class="mb-2 mr-3 pt-1 float-left webview"
                  src="assets/images/fb.png"
                  alt="Facebook Logo"
                  title="Facebook Logo"
                  width="11"
              /></a>
              <a href="https://twitter.com/honestgorilla" target="_blank">
                <img
                  class="mb-2 mr-3 mt-1 float-left webview"
                  src="assets/images/twitter.png"
                  alt="Twitter Logo"
                  title="Twitter Logo"
                  width="22"
              /></a>
              <a
                href="https://www.instagram.com/honestgorilla_energy/ "
                target="_blank"
              >
                <img
                  class="mb-2 mr-3 mt-1 float-left webview"
                  src="assets/images/instgram.png"
                  alt="Instagram Logo"
                  title="Instagram Logo"
                  width="21"
              /></a>
            </div>
            <div class="d-flex mob-align-left">
              <a
                href=" https://www.facebook.com/honestgorilla1/"
                target="_blank"
              >
                <img
                  class="mb-2 mr-3 float-left mobileview"
                  src="assets/images/mbl_footer_fb.svg"
                  alt="Facebook Logo"
                  title="Facebook Logo"
                  width="22"
              /></a>
              <a href="https://twitter.com/honestgorilla" target="_blank">
                <img
                  class="mb-2 mr-3 mt-1 float-left mobileview"
                  src="assets/images/mbl_footer_twitter.svg"
                  alt="Twitter Logo"
                  title="Twitter Logo"
                  width="22"
              /></a>
              <a
                href="https://www.instagram.com/honestgorilla_energy/ "
                target="_blank"
              >
                <img
                  class="mb-2 mr-3 mt-1 float-left mobileview"
                  src="assets/images/mbl_footer_ insta.svg"
                  alt="Instagram Logo"
                  title="Instagram Logo"
                  width="22"
              /></a>
            </div>
          </div>

          <small
            class="d-block mb-3 mt-3 w-100 float-left fs18 cpyright text-white"
            >&copy; {{ licenseHG }}<br />
            TX PUC Broker License #: BR220098.</small
          >
        </div>
      </div>
    </div>
  </div>
</footer>
